export const AGENCY_CARDS_LAYOUT = 'agencyCardsLayoutValue';
export const AGENCY_CARDS_LAYOUT_NORMAL = 'card';
export const AGENCY_CARDS_LAYOUT_FULL = 'horizontal';

export type LayoutType = typeof AGENCY_CARDS_LAYOUT_NORMAL | typeof AGENCY_CARDS_LAYOUT_FULL;
